const login = {
  userPlaceholder: "Please enter the user name",
  userError: "Please enter the user name",
  pwdPlaceholder: "Please enter the password",
  pwdError: "Please enter the password",
  login: "Sign in"
} 
export default login